<template>
  <header id="js-header" class="u-header u-header--static">
    <div class="u-header__section u-header__section--light u-shadow-v18 g-bg-white g-transition-0_3 g-py-10">
      <nav class="js-mega-menu navbar navbar-expand-lg hs-menu-initialized hs-menu-horizontal">
        <div class="container">
          <!-- Responsive Toggle Button -->
          <button
            class="navbar-toggler navbar-toggler-right btn g-line-height-1 g-brd-none g-pa-0 g-pos-abs g-top-minus-3 g-right-0"
            type="button" aria-label="Toggle navigation" aria-expanded="false" aria-controls="navBar"
            data-toggle="collapse" data-target="#navBar">
              <span class="hamburger hamburger--slider">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
              </span>
              </span>
          </button>
          <!-- End Responsive Toggle Button -->

          <!-- Logo -->
          <router-link to="/" class="logo navbar-brand d-flex">
            <span><img src="../../assets/e-smartship.png" style="height: 60px;"></span>
          </router-link>
          <!-- End Logo -->

          <el-menu class="site-nav" :default-active="activeIndex" mode="horizontal">
            <el-menu-item index="home">
              <router-link to="/">關於智郵易</router-link>
            </el-menu-item>
            <el-menu-item index="process">
              <router-link to="/process">寄件流程</router-link>
            </el-menu-item>
            <el-menu-item index="about">
              <router-link to="/about">出口路線</router-link>
            </el-menu-item>
            <el-menu-item index="tracking">
              <router-link to="/tracking">物流追蹤</router-link>
            </el-menu-item>
            <el-menu-item index="post-office">
              <router-link to="/post-office">智郵易投遞網點</router-link>
            </el-menu-item>
            <el-menu-item index="faq">
              <router-link to="/faq">常見問題</router-link>
            </el-menu-item>
            <!--<el-submenu index="info" popper-class="site-nav-submenu">-->
              <!--<template #title>資訊中心</template>-->
              <!--<el-menu-item>-->
                <!--<router-link to="/process">流程簡介</router-link>-->
              <!--</el-menu-item>-->
              <!--<el-menu-item index="price">-->
                <!--<router-link to="/price">收費價目表</router-link>-->
              <!--</el-menu-item>-->
              <!--<el-menu-item index="faq">-->
                <!--<router-link to="/faq">FAQ</router-link>-->
              <!--</el-menu-item>-->
              <!--<el-menu-item index="terms">-->
                <!--<router-link to="/terms">基本條款</router-link>-->
              <!--</el-menu-item>-->
              <!--<el-menu-item index="privacy">-->
                <!--<router-link to="/privacy">私隱政策</router-link>-->
              <!--</el-menu-item>-->
            <!--</el-submenu>-->
            <!--<el-submenu index="services" popper-class="site-nav-submenu">-->
              <!--<template #title>服務查詢</template>-->
              <!--<el-menu-item index="join-us">-->
                <!--<router-link to="/join-us">加入我們</router-link>-->
              <!--</el-menu-item>-->
              <!--<el-menu-item index="shop">-->
                <!--<router-link to="/shop">香港授權代理商</router-link>-->
              <!--</el-menu-item>-->
            <!--</el-submenu>-->
          </el-menu>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '',
    };
  },
  mounted() {
    switch (this.$route.name) {
      case 'process':
        this.activeIndex = 'process';
        break;
      case 'price':
      case 'faq':
      case 'terms':
      case 'privacy':
        this.activeIndex = 'info';
        break;
      case 'shop':
      case 'join-us':
        this.activeIndex = 'services';
        break;
      case 'post-office':
        this.activeIndex = 'post-office';
        break;
      default:
        this.activeIndex = this.$route.name;
        break;
    }
  },
  computed: {},
};
</script>

<style lang="scss">
  @import "../../styles/variables";
  .u-header, .u-header--static {

  }

  .site-nav {
    &.el-menu {
      border-bottom: none!important;
    }
    .el-menu-item {
      //a {
      //  color: $text-alpha-inverse!important;
      //  text-decoration: none;
      //}
    }
  }

  .site-nav-submenu {
    a, a:hover {
      color: $text-alpha-inverse;
      text-decoration: none;
    }
  }
</style>
